import { Stack, styled } from "@mui/material";
import { calendarMonthName } from "../classes.js";
const doNotForward = /* @__PURE__ */ new Set(["ownerState", "dayGapY"]);
const WeeksContainer = styled(Stack, {
  name: calendarMonthName,
  slot: "WeeksContainer",
  overridesResolver: (_, styles) => [styles.weeksContainer],
  shouldForwardProp: (prop) => !doNotForward.has(prop)
})(({ dayGapY }) => ({
  gap: `${dayGapY}px 0px`,
  flexWrap: "wrap",
  alignContent: "flex-start",
  flexDirection: "row"
}));
export {
  WeeksContainer
};
//# sourceMappingURL=WeeksContainer.js.map
